export const Breakpoints = {
  desktop: 1024,
  mobile: 0,
}
